import React from "react";
import img1 from "../Image/Rectangle 34625569.png";
import "./Home.css";
import { Link } from "react-router-dom";

function Begcomplete() {
  return (
    <div>
      <div className="container-fluid home-banner-div1">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div>
                <img src={img1} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-7 home-banner-col2-div1">
              <div className="home-banner-col2-text11">
                <h1>Process Complete !</h1>

                <div className="next-btn-div1">
                  <Link to="/beg">
                    <div className="next-btn2"> Back</div>
                  </Link>

                  {/* <Link to=''><div className='next-btn2'> Next <svg class='ml-3' width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 2.5L8 8.5L2 14.5" stroke="white" stroke-width="4" stroke-linecap="round" />
                                    </svg>
                                    </div></Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Begcomplete;
